export default {
  state: {
    labels: {
      Sessions: {
        color: '#f2842f',
        active: true,
        position: 'left',
      },
      Leads: {
        color: '#47a089',
        active: false,
        position: 'right',
      },
      Sales: {
        color: '#ec5155',
        active: false,
        position: 'right',
      },
      CPL: {
        color: '#55395f',
        active: false,
        position: 'right',
      },
      CPS: {
        color: '#224166',
        active: false,
        position: 'left',
      },
    },
  },
  mutations: {
    SET_ACTIVE_LABEL(state, { label, value }) {
      state.labels[label].active = value
    },
  },
  actions: {
    toggleLabel({ commit, state }, label) {
      if (state.labels[label].active) {
        commit('SET_ACTIVE_LABEL', { label, value: false })
      } else {
        commit('SET_ACTIVE_LABEL', { label, value: true })
      }
    },
  },
  getters: {
    labels(state, getters, rootState) {
      const { sessions, leads, sales, cps, cpl } = rootState.budget.rtb.stats
      return [sessions, leads, sales, cpl, cps].map((item, i) => ({
        total: item.total ? item.total.toLocaleString('en') : 0,
        label: item.title,
        full: i === 2,
        dollar: item.title === 'CPL' || item.title === 'CPS',
        dataset: getters.getDataset(item.dots),
        ...state.labels[item.title],
      }))
    },
  },
}
